import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import {
  Form,
  Input,
  Upload,
  Button,
  Switch,
  Select,
  Row,
  Col,
  Tabs,
  Flex,
  Modal,
  Space,
  Table,
  TableProps,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleFilled,
  PlusCircleOutlined,
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  FetchGroupList,
  deleteGroup,
  addSelectedPart,
  removeSelectedPart,
} from "../../redux/actions/action";
import styles from "./groupListPopup.module.css";
import AddGroupPopup from "./AddGroupPopup";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

function GroupListPopup() {
  const dispatch = useDispatch();

  const groupList = useSelector((state) => {
    return state.user.groupList;
  });

  const fetchParticularAsset = useSelector(
    (state) => state.user.fetchParticularAsset
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Assets-Add").then((data) =>
      setFetchTranslationList(data)
    );
  }, []);

  const [isGroupModal, setIsGroupModal] = useState(false);
  const [addGroupModalOpen, setAddGroupModalOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState([]);

  const [editGroupData, setEditGroupData] = useState([]);

  useEffect(() => {
    dispatch(FetchGroupList());
  }, []);

  useEffect(() => {}, [groupList]);

  const showModal = () => {
    setIsGroupModal(true);
  };

  const handleCancel = () => {
    setIsGroupModal(false);
    setGroupManagerSearch("");
  };

  const showaddGroupModal = () => {
    setEditGroupData([]);
    setAddGroupModalOpen(true);
  };

  const handleshowaddGroupCancel = () => {
    setAddGroupModalOpen(false);
  };

  const handlerEdit = (record) => {
    setEditGroupData([record]);
    setAddGroupModalOpen(true);
  };

  const handleCheckboxChange = (e, record) => {
    if (e.target.checked) {
      // If checkbox is checked, add to the array
      setSelectedGroup([...selectedGroup, record]);

      record.parts.map((part) => {
        dispatch(addSelectedPart(part));
      });
    } else {
      // If checkbox is unchecked, remove from the array
      // setSelectedParts(selectedParts.filter((part) => part.partId !== record.partId));

      record.parts.map((part) => {
        dispatch(removeSelectedPart(part.partId));
      });
    }
  };

  const savedParts = useSelector((state) => state.user.selectedParts);
  console.log("asc33 groups", savedParts);

  const groupTableColumn = [
    {
      title: "",
      dataIndex: "groupId",
      key: "groupId",
      render: (text, record) => {
        const savedPartIds = savedParts.map((item) => item.partId);
        const groupPartIds = record.parts.map((part) => part.partId);

        const isChecked = record.parts.every((part) =>
          savedParts.some((saved) => saved.partId === part.partId),
        );
        return (
          <div className="custom-checkbox-wrap">
            <input
              type="checkbox"
              className={`checkboxQuery-${record.groupId}`} // Assign a unique class.
              checked={isChecked}
              onChange={(e) => handleCheckboxChange(e, record)}
            />
            <span className="checkmark"></span>
          </div>
        );
      },
    },
    {
      // title: "Group Name",
      title: t("Group Name"),
      dataIndex: "groupName",
      key: "groupName",
      render: (text, record) => (
        <div
          onClick={() => {
            setTimeout(() => {
              // Trigger a click event on the element with the class 'fas fa-bars'.
              const targetElement = document.querySelector(
                `.checkboxQuery-${record.groupId}`,
              );
              console.log("asc44", targetElement);
              if (targetElement) {
                targetElement.click(); // Simulate a click event.
              } else {
                console.log('Element with class "profileButton" not found.');
              }
            }, 10);
          }}
        >
          <a>{text}</a>
        </div>
      ),
    },
    {
      title: "Parts",
      dataIndex: "partsCount",
      key: "partsCount",
    },
    {
      title: (
        <Button
          type="text"
          icon={<PlusCircleFilled style={{ color: "#95a7c6" }} />}
          onClick={showaddGroupModal}
        >
          {/* Add New */}
          {t("Add New")}
        </Button>
      ),
      dataIndex: "action",
      render: (text, record) => (
        <>
          <Flex
            gap="small"
            style={{ textAlign: "right" }}
            className="action-btn-wrap"
          >
            <Button
              type="text"
              icon={
                <EditOutlined
                  style={{ color: "#95a7c6" }}
                  onClick={() => {
                    handlerEdit(record);
                  }}
                />
              }
            ></Button>
            <Button
              type="text"
              icon={<DeleteOutlined style={{ color: "#95a7c6" }} />}
              id="deleteGroup"
              onClick={() => {
                dispatch(deleteGroup(record.groupId));
                setTimeout(() => {
                  dispatch(FetchGroupList());
                }, 2000);
              }}
            ></Button>
          </Flex>
        </>
      ),
    },
  ];

  const [groupManagerSearch, setGroupManagerSearch] = useState("");

  return (
    <>
      <div className={styles.add_group_wrap}>
        <Button
          onClick={showModal}
          type="text"
          icon={<PlusCircleFilled style={{ color: "#95a7c6" }} />}
        >
          {/* Add Group */}
          {t("Add Group")}
        </Button>
        <div
          className={`${styles.groupManagerPopup} ${
            isGroupModal ? styles.show : ""
          }`}
        >
          <div className={styles.group_popup_inner}>
            <div className={styles.group_popup_header}>
              <div className={styles.title_wrap}>
                <Flex gap="small" className={styles.flex}>
                  <h2>
                    {/* Group Manager */}
                    {t("Group Manager")}
                  </h2>
                  <div className={styles.search_input}>
                    <input
                      type="text"
                      placeholder="Search"
                      value={groupManagerSearch}
                      onChange={(e) => {
                        setGroupManagerSearch(e.target.value);
                      }}
                    />
                    <Button
                      type="text"
                      shape="circle"
                      icon={<SearchOutlined />}
                    />
                  </div>
                </Flex>
              </div>
              <div className={styles.close_btn_wrap}>
                <Button
                  type="text"
                  shape="circle"
                  icon={<CloseCircleOutlined />}
                  onClick={handleCancel}
                />
              </div>
            </div>
            <div className={styles.popup_body}>
              <div className={`${styles.table_wrapper} group-table-wrapper`}>
                <Table
                  columns={groupTableColumn}
                  dataSource={groupList.filter((item) =>
                    item?.groupName
                      .toLowerCase()
                      .includes(groupManagerSearch.toLowerCase()),
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddGroupPopup
        modalOpen={addGroupModalOpen}
        cancelEvent={handleshowaddGroupCancel}
        groupList={editGroupData}
      />
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(GroupListPopup);
export default GroupListPopup;
